// File upload constraints for All Build Consult
export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024; // 50 MB
export const MAX_FILE_SIZE_LABEL = '50 MB';
export const ALLOWED_USER_UPLOAD_TYPES = ['image/jpeg', 'image/jpg', 'application/pdf'];
export const USER_UPLOAD_ACCEPT_ATTR = '.jpg,.jpeg,.pdf,image/jpeg,application/pdf';
export const ALLOWED_REPORT_TYPES = ['application/pdf'];
export const REPORT_ACCEPT_ATTR = '.pdf,application/pdf';

/**
 * Validate a single file against allowed types and max size.
 * Returns { valid: boolean, error?: string }
 */
export function validateUserFile(file, allowedTypes = ALLOWED_USER_UPLOAD_TYPES) {
  if (!file) return { valid: false, error: 'No file selected' };
  if (!allowedTypes.includes(file.type)) {
    return {
      valid: false,
      error: `${file.name}: unsupported file type. Only JPEG or PDF allowed.`
    };
  }
  if (file.size > MAX_FILE_SIZE_BYTES) {
    const sizeMb = (file.size / (1024 * 1024)).toFixed(1);
    return {
      valid: false,
      error: `${file.name}: file too large (${sizeMb} MB). Maximum is ${MAX_FILE_SIZE_LABEL}.`
    };
  }
  return { valid: true };
}

/**
 * Validate a list of files. Returns { valid: File[], errors: string[] }
 */
export function validateUserFiles(files, allowedTypes = ALLOWED_USER_UPLOAD_TYPES) {
  const valid = [];
  const errors = [];
  for (const file of Array.from(files)) {
    const result = validateUserFile(file, allowedTypes);
    if (result.valid) {
      valid.push(file);
    } else {
      errors.push(result.error);
    }
  }
  return { valid, errors };
}
